export const apiMall = "http://younglife.top/";
export const javaApi = "https://mp.younglife.top:19922/";
export const appName = "优养纪";
export const isOverseas = false;
export const unit = "元";
export const miniProgramUrl = "https://mp.younglife.top:19922/scan";

export const footCopyrightInfo = "Copyright © 2026-2026 杭州捷为科技有限公司";
export const footRecordInformation = "浙ICP备20006941号-6";
export const footGongAnBeianHref = "";
export const footGongAnBeianInformation = "";
export const appId = 'wx3004f438989667f1';
export const isH5 = false; //是否H5
export const h5Url = ''
export const scanToOrderMsg = '微信扫一扫打开小程序下单'
export const isTouchScreen = false; //是否触摸屏(是则移除注册，登录，立即购买按钮)